import React from "react";
import "./style.css";

export default function Loader() {
  return (
    <div className="spinner-container primary">
      <div className="loading-spinner primary">
      </div>
    </div>
  );
}